export const makePageTitle = (pageTitle?: string) => (pageTitle ? `Blinq: ${pageTitle}` : 'Blinq');
